import * as types from "../actions/actionTypes";
import initialState from "./initialState";

const productsReducer = (state = initialState.products, action) => {
  switch (action.type) {
    case types.LOAD_PRODUCTS_SUCCESS:
      return action.products;
    case types.CREATE_PRODUCT_SUCCESS:
      return [...state, { ...action.product }];
    case types.UPDATE_PRODUCT_SUCCESS:
      return state.map(product => (product.id === action.product.id ? action.product : product));
    default:
      return state;
  }
};

export default productsReducer;
